import { useNavigation } from '@react-navigation/core';
import { BaseText, Headline3 } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import {
  ChargingSession,
  Maybe,
  ParkingSession,
} from 'types/generatedSchemaTypes';
import { ParkNavProps } from 'types/navigation';
import BlockerMenuItem from './BlockerMenuItem';
import { useUiStore } from 'stores/uiStore';

const OngoingSessionBlocker = ({
  parkingSession,
  chargingSession,
}: {
  parkingSession?: Maybe<ParkingSession>;
  chargingSession?: Maybe<ChargingSession>;
}) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<ParkNavProps>();

  const goParking = () => {
    useUiStore.getState().setSheetModal('');
    navigate('park');
    useParkingStore.getState().setSelectedOngoingSession('PARKING');
  };
  const goCharging = () => {
    useUiStore.getState().setSheetModal('');
    navigate('park');
    useParkingStore.getState().setSelectedOngoingSession('CHARGING');
  };

  const ParkingTextComponent = (
    <Text>
      <BaseText>{t('account.remove.sessionFront')}</BaseText>
      <Headline3>{t('account.remove.parkingMiddle')}</Headline3>
      <BaseText>{t('account.remove.sessionTail')}</BaseText>
    </Text>
  );

  const ChargingTextComponent = (
    <Text>
      <BaseText>{t('account.remove.sessionFront')}</BaseText>
      <Headline3>{t('account.remove.chargingMiddle')}</Headline3>
      <BaseText>{t('account.remove.sessionTail')}</BaseText>
    </Text>
  );

  return (
    <>
      {parkingSession && (
        <BlockerMenuItem
          text={ParkingTextComponent}
          testID="account-remove-reason-parking"
          onPress={goParking}
        />
      )}
      {chargingSession && (
        <BlockerMenuItem
          text={ChargingTextComponent}
          testID="account-remove-reason-charging"
          onPress={goCharging}
        />
      )}
    </>
  );
};

export default OngoingSessionBlocker;
